import { complexity } from './complexity.validator';
import { confirmPassword } from './confirm-password.validator';
import { email } from './email.validator';
import { httpUrl } from './http-url.validator';
import { maxLength } from './maxLength.validator';
import { password } from './password.validator';
import { range } from './range.validator';
import { regex } from './regex.validator';
import { required } from './required.validator';
import { uuid } from './uuid.validator';
import { whitespace } from './whitespace.validator';

export default {
    range,
    required,
    regex,
    confirmPassword,
    email,
    password,
    httpUrl,
    uuid,
    whitespace,
    maxLength,
    complexity,
};

export * from './constants';
